export default __webpack_public_path__ + "static/media/storycards_logo.0387b642.svg";